<template>
  <v-form>
    <v-container fluid>
      <v-row dense>
        <v-col cols="12">
          <CustomerSearch
            v-if="currentCustomer === null"
            :on-selected="onCustomerAcUpdated"
            :required="true"
          />
          <v-chip v-else>
            {{ currentCustomer.customerNumber }}:
            {{ getProfileItemBasics(currentCustomer.profile, 'firstName') }}
            {{ getProfileItemBasics(currentCustomer.profile, 'lastName') }}
            <template v-if="getProfileItemBasics(currentCustomer.profile, 'company')">
              | {{ getProfileItemBasics(currentCustomer.profile, 'company') }}
            </template>
          </v-chip>
        </v-col>
        <v-col cols="12">
          <v-text-field
            v-if="this.enabledNameAndMail"
            :error-messages="nameErrors"
            :label="$t('ParticipantName')"
            @blur="$v.item.name.$touch()"
            @input="$v.item.name.$touch()"
            v-model="item.name"
            :disabled="!this.enabledNameAndMail"
          />
          <v-text-field
            v-if="this.enabledNameAndMail"
            :error-messages="emailErrors"
            :label="$t('email')"
            @blur="$v.item.email.$touch()"
            @input="$v.item.email.$touch()"
            v-model="item.email"
            :disabled="!this.enabledNameAndMail"
          />
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
  import has from 'lodash/has';
  import { validationMixin } from 'vuelidate';
  import { email, requiredIf } from 'vuelidate/lib/validators';
  import TenantMixin from '../../mixins/TenantMixin';
  import ProfileMixin from '@/mixins/ProfileMixin';
  import CustomerMixin from '@/mixins/CustomerMixin';
  import CustomerSearch from '@/components/customer/Search.vue';
  import { required } from 'vuelidate/lib/validators';

  export default {
    name: 'SubscriberForm',
    components: { CustomerSearch },
    mixins: [validationMixin, TenantMixin, ProfileMixin, CustomerMixin],
    props: {
      values: {
        type: Object,
        required: true
      },
      currentSubscribers: {
        type: Array,
        required: false
      },
      errors: {
        type: Object,
        default: () => { }
      },
      initialValues: {
        type: Object,
        default: () => { }
      },
      currentCustomer: {
        type: Object,
        default: () => null
      },
    },
    data() {
      return {
        currentSelectedCustomer: null,
      };
    },
    computed: {
      item() {
        return this.initialValues || this.values;
      },
      currentCustomerObject: {
        get() {
          return this.currentCustomer
        },
        set(currentCustomer) {
          return currentCustomer
        }
      },
      enabledNameAndMail() {
        return false;
        // currently no name / mail for business, just use the business customer
        // return this.currentSelectedCustomer?.isBusiness;
      },
      nameErrors() {
        const errors = [];
        if (this.$v.item.name) {
          if (!this.$v.item.name.$dirty) {
            return errors;
          }

          has(this.violations, 'name') && errors.push(this.violations.name);

          !this.$v.item.name.required && errors.push(this.$t('Field is required'));
        }
        return errors;
      },
      emailErrors() {
        const errors = [];
        if (this.$v.item.email) {
          if (!this.$v.item.email.$dirty) {
            return errors;
          }

          has(this.violations, 'email') && errors.push(this.violations.email);

          !this.$v.item.email.email && errors.push(this.$t('Invalid email address.'));
        }
        return errors;
      },
      violations() {
        return this.errors || {};
      },
    },
    methods: {
      onCustomerAcUpdated(selectedCustomer) {
        this.$emit('selectedCustomer', selectedCustomer);
        if (selectedCustomer) {
          this.item.customer = selectedCustomer['@id'];
          this.currentSelectedCustomer = selectedCustomer;
        } else {
          this.item.customer = null;
          this.currentSelectedCustomer = null;
        }
      }
    },
    validations: {
      item: {
        customer: {
          required
        },
        name: {
          required: requiredIf(function () {
            return this.enabledNameAndMail;
          })
        },
        email: {
          email,
        },
      }
    },
  };
</script>
